{
  "round_statistics": "Kierrostilastot",
  "no_stats_tracked": "Tilastoja ei seurattu tällä kierroksella",
  "no_stats_available": "Tilastoja ei ole saatavilla",
  "fairway_accuracy": "Väyläosumatarkkuus",
  "total_fairways_attempted": "Väyläosumat yhteensä",
  "fairway_hit_percentage": "Väyläosuma-%",
  "center": "Keskellä",
  "left": "Vasen",
  "right": "Oikea",
  "short": "Lyhyt",
  "long": "Pitkä",
  "green_accuracy": "Greeniosumat",
  "total_greens_attempted": "Greenit yhteensä",
  "greens_in_regulation": "Greeniosumat (GIR)",
  "gir_percentage": "GIR-%",
  "on_green": "Greenillä",
  "putting_performance": "Puttaaminen",
  "total_putts": "Putit yhteensä",
  "avg_per_hole": "Keskiarvo per reikä",
  "avg_per_gir": "Keskiarvo per GIR",
  "first_putt_distribution": "Ensimmäisen putin jakauma",
  "sunk_putt_distribution": "Uponneiden puttien jakauma",
  "chip_proximity": "Chippien osumatarkkuus (1. putti)",
  "approach_proximity": "Lähestymistarkkuus (1. putti)",
  "proximity_holed": "Sisään",
  "holes_count": "{{count}} reikää",
  "one_putts": "1 Putti",
  "total_sinked": "Uponneita putteja yhteensä",
  "short_game": "Lähipeli",
  "total_chips": "Chipit yhteensä",
  "up_and_downs": "Up and Downit",
  "up_and_down_percentage": "Up and Down-%",
  "bunker_play": "Bunkkeripeli",
  "total_bunker_shots": "Bunkkerista yhteensä",
  "sand_saves": "Sand Savet",
  "sand_save_percentage": "Sand Save-%",
  "penalties": "Rangaistuslyönnit",
  "total_penalties": "Rangaistuslyönnit yhteensä",
  "birdies": "Birdiet",
  "three_putts": "3+ Puttia",
  "fairway": "Väylä",
  "gir_short": "GIR",
  "score_distribution": "Tulosjakauma",
  "eagle_or_better": "Eagle tai <",
  "birdie": "Birdie",
  "par": "Par",
  "bogey": "Bogey",
  "double_bogey_or_worse": "Tupla tai >",
  "total_scored_holes": "Pelatut reiät yhteensä",
  "dashboard": {
    "title": "Omat tilastot",
    "year": "Vuosi",
    "season": "Kausi {{year}}",
    "course": "Kenttä",
    "allYears": "Kaikki vuodet",
    "allCourses": "Kaikki kentät",
    "updating": "Päivitetään...",
    "loadError": "Tilastojen lataaminen epäonnistui",
    "overview": {
      "title": "Yleiskatsaus",
      "avgScore": "Tulos ka.",
      "fir": "FIR",
      "gir": "GIR",
      "avgPutts": "Putit ka."
    },
    "tabs": {
      "results": "Tulokset",
      "accuracy": "FIR/GIR",
      "putting": "Putit",
      "other": "Muut"
    },
    "accuracyStats": {
      "fairway": "Väyläosumat",
      "fairwayLeft": "Vasen",
      "fairwayRight": "Oikea",
      "gir": "Griiniosumat",
      "greenLeft": "Vasen",
      "greenRight": "Oikea",
      "greenShort": "Lyhyt",
      "greenLong": "Pitkä"
    },
    "totalRounds": "Kierroksia",
    "totalHoles": "Reikiä",
    "avgScore": "Keskiarvo",
    "avgToPar": "Ka. par-tulokseen",
    "scoring": "Tulokset",
    "accuracy": "Väyläosumatarkkuus",
    "putting": "Puttaaminen",
    "other": "Muut tilastot",
    "metric": "Tunnusluku",
    "you": "Sinä",
    "friends": "Kaverit",
    "global": "Kaikki",
    "bestScore": "Paras scratch-tulos",
    "worstScore": "Huonoin tulos",
    "eagles": "Eaglet",
    "birdies": "Birdiet",
    "pars": "Parit",
    "bogeys": "Bogeyt",
    "doubleBogeys": "Tuplat",
    "triplePlus": "+3 tai huonommat",
    "fairwayHit": "Väylä %",
    "gir": "GIR %",
    "upAndDown": "Up & Down %",
    "sandSave": "Sand save %",
    "avgPuttsPerHole": "Ka. putteja/reikä",
    "avgPuttsPerRound": "Ka. putteja/kierros",
    "totalPutts": "Putteja yhteensä",
    "totalChips": "Chippejä",
    "totalBunkerShots": "Bunkkerilyöntejä",
    "avgChipsPerRound": "Ka. chippejä/kierros",
    "avgBunkerShotsPerRound": "Ka. bunkkerilyöntejä/kierros",
    "avgPenaltiesPerRound": "Ka. rangaistuksia/kierros",
    "totalPenalties": "Rangaistuksia yhteensä",
    "fullRoundsOnly": "Vain täydet kierrokset",
    "scratchScoring": "Scratch-tulokset",
    "bestRound": "Paras kierros",
    "avgRound": "Kierroskeskiarvo",
    "best9Holes": "Paras 9-reikäinen kierros",
    "avg9Holes": "9-reikäisten kierroskeskiarvo",
    "netScoring": "Tasoitukselliset tulokset",
    "rounds": "kierrosta",
    "holeStats": "Reikätulokset"
  }
}
